import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../../../utilities/breakpoints';
import { ImageContainer } from '../ui';
import Media from './Media';

const SlideShowContainer = styled.div<{ isHidden: boolean }>`
    max-width: 100%;
    height: 100%;
    display: ${props => (props.isHidden ? 'none' : 'grid')};
`;

const StyledButton = styled(Button)<{ position: 'left' | 'right' }>`
    position: absolute;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.7);
    border: none;
    color: #fff;
    padding: 0;

    width: 40px;
    height: 40px;
    font-size: 1.3rem;
    top: calc(50% - 20px);

    &.ant-btn {
        margin-left: 0;
    }

    ${({ position }) => position === 'left' && 'left: 0;'}
    ${({ position }) => position === 'right' && 'right: 0;'}

    &:hover {
        background-color: rgba(0, 0, 0, 0.7);
        border: none;
        color: #fff;
    }

    &:focus {
        background-color: rgba(0, 0, 0, 0.7);
        border: none;
        color: #fff;
    }

    &:active {
        background-color: rgba(0, 0, 0, 0.7);
        border: none;
        color: #fff;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        top: 50%;
        width: 3.5rem;
        height: 3.5rem;
        font-size: 2rem;
    }
`;

export type SlideShowProps = {
    images: { fileName: string; source: string }[];
};

const SlideShow = ({ images }: SlideShowProps) => {
    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <>
            {images.map((item, index) => (
                <SlideShowContainer key={item.source} isHidden={selectedIndex !== index}>
                    <ImageContainer>
                        <Media fileName={item.fileName} source={item.source} />
                    </ImageContainer>
                    {images.length > index + 1 && (
                        <StyledButton onClick={() => setSelectedIndex(prevState => prevState + 1)} position="right">
                            <RightOutlined />
                        </StyledButton>
                    )}
                    {index > 0 && (
                        <StyledButton onClick={() => setSelectedIndex(prevState => prevState - 1)} position="left">
                            <LeftOutlined />
                        </StyledButton>
                    )}
                </SlideShowContainer>
            ))}
        </>
    );
};

export default SlideShow;
